import apiRoutes from './api.routes';
import ModelService from './model.service';
import api from './api.service';

const ChannelsService = new ModelService(apiRoutes.channels, '/channels');
ChannelsService.modelName = 'channels';// ???


ChannelsService.updateMessage = async ({ props, id }) => api.catchError(async () => {
  const url = props.id ? `/channels/${id}/messages/${props.id}` : `/channels/${id}/messages`;
  const { data } = await api[props.id ? 'put' : 'post'](url, props);
  return data;
});

ChannelsService.getMessages = async ({ props, id }) => api.catchError(async () => {
  const { data } = await api.get(`/channels/${id}/messages`, props);
  return data;
});

ChannelsService.removeMessage = async ({ messageId, id }) => api.catchError(async () => {
  const data = await api.destroy(`/channels/${id}/messages/${messageId}`);
  return data;
});

ChannelsService.readMessage = async ({ id, count }) => api.catchError(async () => {
  if (count) {
    const { data } = await api.get(`/channels/${id}/read`, { count });
    return data;
  }
});

ChannelsService.getUsersDirect = async params => api.catchError(async () => {
  const { data } = await api.get('/channels/users-without-direct', params);
  return data;
});

ChannelsService.search = async params => api.catchError(async () => {
  const data = await api.get(`${ChannelsService.baseUrl}/search`, params);
  return data;
});

ChannelsService.createNewDirect = async user_id => api.catchError(async () => {
  const { data } = await api.get(`${ChannelsService.baseUrl}/direct/${user_id}`);
  return data;
});

ChannelsService.TYPE_SUPPORT = 1;
ChannelsService.TYPE_DIRECT_TEAM = 2;
ChannelsService.TYPE_DIRECT_CUSTOMER = 3;
ChannelsService.TYPE_TEAM_CUSTOMER = 4;

export default ChannelsService;



// WEBPACK FOOTER //
// ./src/services/channels.service.js